<template lang="pug">
.product-form-selling-plans
  fieldset.product-form-selling-plans__purchase-types
    legend.h5.product-form-selling-plans__input-label Buy Online
    radio-input.product-form-selling-plans__purchase-type-input(
      v-for="(type, index) in purchaseTypeOptions"
      :value="type"
      v-model="purchaseType"
      :key="`type_${type}_${_uid}`"
      :id="`purchase_type_${type}_${index}`"
      :name="`purchase_type`"
      :checked="type === purchaseType"
    )
      span(v-html="labels[type]")
  transition(name="fade")
    .product-form-selling-plans__selection(
      v-if="purchaseType === 'autodeliver'"
    )
      div.product-form-selling-plans__select-wrapper
        select-input.product-form-selling-plans__select.product-form-selling-plans__select--hidden(
          id="sellingPlans"
          :options="sellingPlanSelectOptions"
          v-model="sellingPlan"
          :label="widgetSettings.widget_deliver_every"
          :selected="sellingPlan.id"
          :disable-default="true"
          :show-native-select="true"
          :required="true"
          :force-native="true"
          :hide-label="true"
        )
</template>

<script>
  import Icon from "scripts/components/basic/Icon.vue";
import RadioInput from "scripts/components/forms/RadioInput.vue";
import SelectInput from "scripts/components/forms/SelectInput.vue";
import { mapState } from "vuex";
  export default {
    name: "ProductFormSellingPlans",
    components: { 
      Icon,
      RadioInput,
      SelectInput
    },
    props: {
      product: Object,
    },
    data() {
      return {
        purchaseTypeOptions: ["onetime", "autodeliver"],
        sellingPlanGroupIndex: 0,
        presetShippingInterval: this.$shop.settings.subscription_shipping_interval_preset || 2,
      };
    },
    computed: {
      ...mapState({
        purchaseType: ({ productPage }) => productPage.purchaseType,
        sellingPlans: ({ productPage }) => productPage.sellingPlans,
        sellingPlan: ({ productPage }) => productPage.sellingPlan,
      }),
      purchaseType: {
        get() {
          return this.$store.state.productPage.purchaseType;
        },
        set(purchaseType) {
          this.$store.dispatch("productPage/setPurchaseType", purchaseType);
        },
      },
      sellingPlan: {
        get() {
          return this.$store.state.productPage.sellingPlan;
        },
        set(plan) {
          let selectedPlan = null;

          if (typeof plan === 'number') {
            const id = plan;
            selectedPlan = this.sellingPlanGroup.selling_plans.find(
              currentPlan => currentPlan.id === id
            );
          } else {
            selectedPlan = this.sellingPlanGroup.selling_plans.find(
              currentPlan => currentPlan.id === plan.id
            );
          }

          this.$store.dispatch("productPage/setSellingPlan", selectedPlan);
        },
      },
      widgetSettings() {
        return this.$shop.subscriptions;
      },
      sellingPlanGroup() {
        return this.product.selling_plan_groups[this.sellingPlanGroupIndex];
      },
      sellingPlanSelectOptions() {
        if (!this.sellingPlans || !this.sellingPlans.length) return [];
        return this.sellingPlans.map((plan, index) => {
          let planName = plan.name.replace(`${this.widgetSettings.widget_deliver_every} `, "");
          return {
            label: planName,
            value: plan.id
          };
        });
      },
      sellingPlanPriceAdjustment() {
        if (!this.sellingPlan) return null;
        if (!this.sellingPlan.price_adjustments || !this.sellingPlan.price_adjustments.length) return null;
        return this.sellingPlan.price_adjustments[0];
      },
      sellingPlanPriceAdjustmentUnit() {
        if (this.sellingPlanPriceAdjustment.value_type === "percentage")
          return "%";
        return "";
      },
      onetimeLabel() {
        return this.widgetSettings.onetime_message || "One-Time Purchase";
      },
      autodeliverLabel() {
        let label = this.widgetSettings.subscribe_message;

        if (
          !!this.sellingPlanPriceAdjustment &&
          this.sellingPlanPriceAdjustment.value !== 0
        )
          label += ` ${this.sellingPlanPriceAdjustment.value}${this.sellingPlanPriceAdjustmentUnit}`;
        else label = "Subscription"; // Recharge widget setting "subscription option verbiage" (non discount message) not available in metafields - hardcode

        return label || "Subscription";
      },
      labels() {
        return {
          onetime: this.onetimeLabel,
          autodeliver: this.autodeliverLabel,
        };
      },
    },
    created() {
      this.$store.dispatch(
        "productPage/setSellingPlans",
        this.sellingPlanGroup.selling_plans
      );
    },
    mounted() {
      this.$store.dispatch(
        "productPage/setSellingPlan",
        this.sellingPlanGroup.selling_plans[0]
      );
    },
    methods: {
    }
  };
</script>

<style lang="scss" scoped>

  $spacing-unit: 10px;

  .product-form-selling-plans {
    display: flex;
    flex-direction: column;
  }

  .product-form-selling-plans select:hover {
    background-color: transparent;
  }

  .product-form-selling-plans__selection {
    display: flex;
  }

  .product-form-selling-lans__select label,
  .product-form-selling-plans__select-label {
    align-items: center;
    display: flex;
    min-width: 110px;
  }

  .product-form-selling-plans__input-label {
    margin-bottom: 16px;
  }

  .product-form-selling-plans__select.input--tertiary {
    @include mobile-only {
      opacity: 0;
    }
  }

  .product-form-selling-plans__purchase-type-input {
    white-space: nowrap;
    margin-bottom: 0;

    @include tablet-up {
      margin-bottom: $spacing-unit * 1.6;
    }

    &:first-of-type {
      margin-bottom: $spacing-unit * 1.6;
    }
  }

  .product-form-selling-plans__selection {
    flex: 1;
    margin-top: $spacing-unit * 1.2;
    text-align: left;

    @include tablet-up {
      margin-top: 0;
      margin-bottom: $spacing-unit * 2.4;
    }
  }

  .product-form-selling-plans__select-wrapper {
    position: relative;
    margin-bottom: 0;
    vertical-align: middle;
    width: 100%;
  }

  .product-form-selling-plans__select {
    margin-bottom: 0;
    top: 0;
    width: 100%;

    /deep/ select,
    /deep/ .select {
      border: 1px solid var(--color-grey-500);
      color: var(--color-navy-500);
      font-size: rem(16px);
      line-height: rem(22px);
      height: 36px;
      max-width: 140px;
      padding: 0 5px;
      -webkit-appearance: none;
      -moz-appearance: none;
      text-indent: 1px;
      text-overflow: '';
    }

    /deep/ .icon {
      fill: var(--color-navy-500);
      top: 7px;
      transform: none;

      @include mobile-only {
        width: 15px !important;
        height: 15px !important;
      }
    }

    /deep/ .vs--open .vs__dropdown-menu {
      min-width: 0;
      max-width: 140px;
    }

    /deep/ .vs__dropdown-toggle {
      padding: 3px 5px;
      min-width: 140px;
    }
  }

  .product-form-selling-plans__select--hidden {
    color: var(--color-navy-500);
    display: flex;

    @include mobile-only {
      position: relative;
      max-width: 250px;
    }

    label { 
      min-width: 115px;
    }

    /deep/ .v-select .vs__selected {
      color: var(--color-navy-500);
      opacity: 1;
      visibility: visible;
    }
  }

  .input--radio__label__content input {
    display: none;
  }

  .input--radio input[type=radio] {
    display: block;
    display: none;
  }

</style>
